"use client";

import React, { createContext, useContext } from "react";
import type { View } from "@/types/board";

// View scope: when set, every nested hook/component (including useBoard's
// own helper accessors — see boardContext) should operate on this view
// instead of the board's active tab. One provider per dashboard widget;
// downstream callers don't have to thread the view through props.

const ViewScopeContext = createContext<View | null>(null);

export function ViewScopeProvider({ view, children }: { view: View; children: React.ReactNode }) {
  return <ViewScopeContext.Provider value={view}>{children}</ViewScopeContext.Provider>;
}

/** Returns the widget view if we're inside a ViewScopeProvider, else null. */
export function useViewScope(): View | null {
  return useContext(ViewScopeContext);
}

